import activeDialog from './active-dialog';

export default {
  activeDialog,
};
